export default "__VITE_ASSET__CVGmwiFk__"